var React = require('react');

function Info (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"currentColor","fillRule":"evenodd","d":"M10 2c4.418 0 8 3.582 8 8s-3.582 8-8 8-8-3.582-8-8 3.582-8 8-8zm0 7c-.513 0-.936.386-.993.883L9 10v4c0 .552.448 1 1 1 .513 0 .936-.386.993-.883L11 14v-4c0-.552-.448-1-1-1zm0-4c-.552 0-1 .448-1 1s.448 1 1 1 1-.448 1-1-.448-1-1-1z"}));
}

Info.defaultProps = {"width":"20","height":"20","viewBox":"0 0 20 20"};

module.exports = Info;

Info.default = Info;
